import createSite from './create-site';
import setTemplatesData from './set-templates-data';

export default {
  createSite,
  setTemplatesData,
};
